import { z } from 'zod';

export const GetCuratorUserInfoServiceResponseSchema = z
  .object({
    platform: z.string(),
    userId: z.string(),
    registeredDate: z.string().optional(),
    snsTitle: z.string().optional(),
  })
  .describe('GetCuratorUserInfoServiceResponseSchema');

export type GetCuratorUserInfoServiceResponse = z.infer<
  typeof GetCuratorUserInfoServiceResponseSchema
>;
